import { Colors } from './colors';
export const Heading = {
  // The styles all Cards have in common
  baseStyle: {
    background: 'white',
    alignItems: 'center',
    gap: 6,
  },
  // Two variants: rounded and smooth
  variants: {
    pageTitle: {
      fontWeight: 600,
    },
    offerDetails: {
      background: '#FFFFFF',
      fontWeight: 400,
      color: Colors.tableTitles,
      display: 'flex',
    },
  },
  // The default variant value
  defaultProps: {
    variant: 'offerDetails',
  },
};
